import React from "react";
import { useSearchParams } from "react-router-dom";

const PaymentResultPage = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status"); // success | failed | cancelled

  const isSuccess = status === "success";
  const isCancelled = status === "cancelled";

  const config = isSuccess
    ? { icon: "✅", title: "Payment Successful!", message: "Your plan is now active. You can see your updated plan under Profile → My Plans after refresh.", color: "#16a34a" }
    : isCancelled
    ? { icon: "ℹ️", title: "Payment Cancelled", message: "You cancelled the payment. No amount was charged.", color: "#2563eb" }
    : { icon: "❌", title: "Payment Failed", message: "Something went wrong. Please try again from the app. If any amount was deducted, it will be refunded within 48 hours.", color: "#dc2626" };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ fontSize: "48px" }}>{config.icon}</div>
        <h2 style={{ ...styles.title, color: config.color }}>{config.title}</h2>
        <p style={styles.message}>{config.message}</p>
        <div style={styles.divider} />
        <p style={styles.instruction}>You can now close this page and return to the app.</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9fafb",
    padding: "16px",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "40px 28px",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 700,
    margin: "16px 0 8px",
  },
  message: {
    fontSize: "1rem",
    color: "#555",
    margin: "0 0 24px",
  },
  divider: {
    height: "1px",
    background: "#e5e7eb",
    margin: "0 0 24px",
  },
  instruction: {
    fontSize: "0.95rem",
    color: "#333",
    fontWeight: 600,
  },
};

export default PaymentResultPage;
